import React from "react";
import PropTypes from "prop-types";
import { TaskSheet } from "./TaskSheet";
import { useListColumnNavigation } from "../../Hooks";

export const ListColumnNavigation = React.forwardRef(({ taskId, ...props }, ref) => {
  const [prev, next] = useListColumnNavigation(taskId);
  return (
    <TaskSheet
      ref={ref}
      taskId={taskId}
      prev={prev}
      next={next}
      {...props}
    />
  );
});

ListColumnNavigation.propTypes = {
  taskId: PropTypes.number,
};

ListColumnNavigation.displayName = "ListColumnNavigation";
